module.exports = window.wp?.blocks;